import styled from 'styled-components';
import Text14 from '@sdk/components/ui/typography/Text14';

export const PlanBreakdownColumn = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const PlanBreakdownText = styled(Text14)`
  color: ${({ theme }) => theme.colors.gray};
`;
